import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setActivitiesPerPage } from '../../redux/actions';
import useFilterParams from './useFilterParams';

export function useFilterModalValues() {
  const DEFAULT_VALUES = { actions: [], date_from: '', date_to: '', locations: [], performers: [] };
  const [values, setValues] = useState(DEFAULT_VALUES);
  const {
    activitiesFilters: { data: filters },
  } = useSelector((state) => state.activitiesReducer);
  const dispatch = useDispatch();
  const { updateSearchParamsWithObject } = useFilterParams();

  const handleUpdateValues = (value) => {
    setValues(value);
  };

  const formatFilterModalValues = () => {
    const defaultValues = { ...DEFAULT_VALUES };
    if (filters.actions) {
      defaultValues.actions = filters.actions.split(',');
    }
    if (filters.location_id)
      defaultValues.locations = filters.location_id.split(',').map((e) => {
        const [locationType, locationId] = e.split('-');
        return `${locationType}-${locationId}`;
      });
    if (filters.performer_id) defaultValues.performers = filters.performer_id.split(',').map((e) => parseInt(e, 10));
    if (filters.date_from) defaultValues.date_from = filters.date_from.replace(' ', '+');
    if (filters.date_to) defaultValues.date_to = filters.date_to.replace(' ', '+');
    setValues(defaultValues);
  };

  const handleClearFilters = () => {
    setValues(DEFAULT_VALUES);
    dispatch(setActivitiesPerPage({ data: 25 }));
    updateSearchParamsWithObject({ page: 1, per_page: 25 });
  };

  useEffect(() => {
    formatFilterModalValues();
  }, [filters]);

  return { DEFAULT_VALUES, handleClearFilters, handleUpdateValues, values };
}

export default useFilterModalValues;
